import React, { Component } from 'react'
import { connect } from 'react-redux';
import { fetchHours } from '../../redux/actions';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import Map from '../../components/Map/Map.js';
import Address from '../../components/Address.js';
import NewsLetter from '../../components/NewsLetter/NewsLetter.js';
import './Footer.css';
import Hours from '../../components/Hours';
import { Link } from 'react-router-dom';

class Footer extends Component {
  componentDidMount() {
    if (!this.props.hours) {
      this.props.fetchHours(this.props.intl.locale);
    }
  }

  render() {
    return (
        <div>
            <Map/>
            <footer className="app-footer">
              <Address/>
              <div>
                <h4><FormattedMessage id="footer.openTitle" /></h4>
                <Hours text={this.props.hours}/>
                <p><FormattedMessage id="footer.otherTimes" /></p>
              </div>
              <NewsLetter/>
              <div>
                <h4>&nbsp;</h4>
                <Link to="/reservation" className="footer-link">{this.props.intl.messages["general.bookTable"]}</Link>
                {/*<Link to="/yrityskortti" className="footer-link">{this.props.intl.messages["general.businessCard"]}</Link>*/}
                <Link to="/lahjakortti" className="footer-link">{this.props.intl.messages["general.giftCard"]}</Link>
                {/* <a href="https://www.bw-restaurants.fi/" className="footer-link">BW-Restaurants Oy</a>*/}
                <a href="/asiakasrekisterin-tietosuojaseloste" className="footer-link"><FormattedMessage id="footer.privacyPolicy" /></a>
                <a href="/b2b-suoramarkkinoinnin-tietosuojaseloste" className="footer-link"><FormattedMessage id="footer.b2bPrivacyPolicy" /></a>
                <a href="/verkkokaupan-toimitusehdot" className="footer-link">{this.props.intl.messages["footer.webshopTerms"]}</a>
                {/* <a href="https://www.bw-restaurants.fi/kuvapankki" className="footer-link">{this.props.intl.messages["general.forMedia"]}</a>*/}
                <a href="https://www.oivahymy.fi/hae-yrityksia/#text=Boulevard" target="_blank" rel="noopener noreferrer" className="footer-link">{this.props.intl.messages["general.oiva"]}</a>
              </div>
            </footer>
        </div>
    )
  }
}

Footer.propTypes = {
  intl: intlShape.isRequired,
}

const mapStateToProps = state => ({
  hours: state.hours,
});

const mapDispatchToProps = {
  fetchHours,
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Footer));


// WEBPACK FOOTER //
// ./src/containers/Footer/Footer.js